import type { ComponentProps } from 'react';
import { TableHeader as AriaTableHeader } from 'react-aria-components';
import clsx from 'clsx';

import { useTableVariant } from './Table';

import styles from './TableHeader.module.css';

type Props = ComponentProps<typeof AriaTableHeader>;

export const TableHeader = ({ children, ...props }: Props) => {
  const variant = useTableVariant();

  return (
    <AriaTableHeader
      {...props}
      className={clsx(props.className, styles.TableHeader, { [styles.slim]: variant === 'slim' })}
    >
      {children}
    </AriaTableHeader>
  );
};
